import api, { ResponseCallback } from '../services/api.service'
import routeUtil from '../utils/route.util'
import { AddonName, AddonData } from './addon.api'
import { MetaAttributeData } from './metaAttribute.api'
import { SubscriberData } from './subscriber.api'

export interface MetaData {
  id: number
  subscriberId: number
  addonId: number
  value?: string
  deletedAt?: string
  createdAt: string
  updatedAt: string
  isDeleted: boolean
  subscriber?: SubscriberData
  addon?: AddonData
  attribute?: MetaAttributeData
}

export interface MetaCreateRequest {
  subscriber?: number
  addon?: number
  value?: string
  attributable?: number
}

export interface MetaUpdateRequest {
  value?: string
}

export interface MetaExistByAddonNameResponse {
  exist?: boolean
}

const routes = {
  list: '/metas',
  delete: '/metas/{id}',
  create: '/metas',
  read: '/metas/{id}',
  update: '/metas/{id}',
  listByItemAttribute: '/metas/attributes/items/{itemId}',
  listByCategoryAttribute: '/metas/attributes/category/{itemId}',
  existByAddonName: '/metas/addon/{addon}/exist'
}

export default {
  list (callback: ResponseCallback<MetaData[]>) {
    api.get(routes.list, {}, callback)
  },

  delete (id: number, callback: ResponseCallback<MetaData>) {
    const url = routeUtil.replaceParams(routes.delete, { id })
    api.delete(url, {}, callback)
  },

  create (payload: MetaCreateRequest, callback: ResponseCallback<MetaData>) {
    api.post(routes.create, payload, callback)
  },

  read (id: number, callback: ResponseCallback<MetaData>) {
    const url = routeUtil.replaceParams(routes.read, { id })
    api.get(url, {}, callback)
  },

  update (
    id: number,
    payload: MetaUpdateRequest,
    callback: ResponseCallback<MetaData>
  ) {
    const url = routeUtil.replaceParams(routes.update, { id })
    api.patch(url, payload, callback)
  },

  listByItemAttribute (itemId: number, callback: ResponseCallback<MetaData[]>) {
    const url = routeUtil.replaceParams(routes.listByItemAttribute, { itemId })
    api.get(url, {}, callback)
  },

  listByCategoryAttribute (itemId: number, callback: ResponseCallback<MetaData[]>) {
    const url = routeUtil.replaceParams(routes.listByCategoryAttribute, { itemId })
    api.get(url, {}, callback)
  },

  existByAddonName (
    addon: AddonName,
    callback: ResponseCallback<MetaExistByAddonNameResponse>
  ) {
    const url = routeUtil.replaceParams(routes.existByAddonName, { addon })
    api.get(url, {}, callback)
  }
}
